import React, { useState } from "react";

const TYPE_STYLE = {
  "Manager Review":      "text-[#00ff90] bg-[#00ff90]/10 border-[#00ff90]/20",
  "Self Review":         "text-blue-400 bg-blue-500/10 border-blue-500/20",
  "Peer Review Approve": "text-purple-400 bg-purple-500/10 border-purple-500/20",
  "360 Feedback":        "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
};

export default function ReviewQueue({ loading, items, onComplete, onApprove }) {
  const [comments, setComments] = useState({});
  const setComment = (id, val) => setComments(c => ({ ...c, [id]: val }));

  if (loading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="h-20 rounded-xl border border-[#00ff90]/20 bg-[#0d0d0d] animate-pulse" />
        ))}
      </div>
    );
  }

  if (!items?.length) {
    return <p className="text-white/30 text-sm py-4 text-center italic">No pending reviews.</p>;
  }

  return (
    <div className="space-y-3">
      {items.map(x => {
        const typeStyle = TYPE_STYLE[x.type] || "text-white/50 bg-white/5 border-white/10";
        const isDone = x.status !== "PENDING";

        return (
          <div key={x.id} className="rounded-xl border border-[#00ff90]/15 bg-[#0d0d0d] p-4">
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <span className="text-sm font-medium text-white">{x.name}</span>
                  <span className="text-xs text-white/30">{x.role}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full border ${typeStyle}`}>{x.type}</span>
                </div>
                <p className="text-xs text-white/40">
                  Due {x.due}
                  {x.period && <> · {x.period}</>}
                </p>
              </div>

              {isDone ? (
                <span className={`text-xs px-2.5 py-1 rounded-full border shrink-0 ${
                  x.status === "APPROVED"   ? "border-[#00ff90]/20 text-[#00ff90]/50 bg-[#00ff90]/5" :
                  x.status === "COMPLETED"  ? "border-blue-500/20 text-blue-400/50 bg-blue-500/5" :
                  "border-white/10 text-white/30 bg-white/5"
                }`}>{x.status}</span>
              ) : (
                <div className="flex items-center gap-2 shrink-0 flex-wrap">
                  <input
                    placeholder="Comment (optional)"
                    value={comments[x.id] || ""}
                    onChange={e => setComment(x.id, e.target.value)}
                    className="bg-black border border-white/10 rounded-lg px-3 py-1.5 text-xs text-white outline-none focus:border-[#00ff90]/30 transition-colors w-40"
                  />
                  <button onClick={() => onComplete?.(x.id, comments[x.id] || "")}
                    className="text-xs px-3 py-1.5 rounded-lg border border-blue-500/25 bg-blue-500/8 text-blue-400/70 hover:bg-blue-500/15 hover:text-blue-400 transition-colors">
                    Mark Done
                  </button>
                  <button onClick={() => onApprove?.(x.id, comments[x.id] || "")}
                    className="text-xs px-3 py-1.5 rounded-lg border border-[#00ff90]/25 bg-[#00ff90]/8 text-[#00ff90]/70 hover:bg-[#00ff90]/15 hover:text-[#00ff90] transition-colors">
                    Approve
                  </button>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}